'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyFAQs: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.faqs')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-user-content-illustration.svg"
      variant="subtle"
    />
  )
}
